/* ============================================================
 * bundle-quantity.js — v3 (affichage seul)
 * ------------------------------------------------------------
 * RÔLE (volontairement limité à ce qui est possible côté thème) :
 *   1. Afficher les paliers de quantité (boutons radio) avec, pour
 *      chaque palier, le prix plein BARRÉ + le prix réduit du palier.
 *   2. Quand l'utilisateur choisit un palier, fixer la QUANTITÉ
 *      envoyée au panier.
 *   3. Ajouter au panier la bonne quantité.
 *
 * CE QUE CE SCRIPT NE FAIT PLUS (et ne doit PAS faire) :
 *   - Forcer / "pousser" un prix au checkout : IMPOSSIBLE côté thème.
 *     La VRAIE réduction est appliquée par une discount Function
 *     (Functions Creator), côté serveur, jusqu'au checkout.
 *   - Intégration LPO / surcoûts d'options dans les totaux affichés :
 *     SUPPRIMÉE (c'était la source des boucles d'events `options:price`
 *     et du bug "tout devient CHF"). Les surcoûts d'options restent
 *     gérés par LPO et s'ajoutent au panier, séparément.
 *   - La propriété de ligne `properties[BundleQty]` : supprimée
 *     (inutile, la Function lit la quantité de la ligne).
 *
 * SOURCE DE VÉRITÉ DU PRIX : le métachamp `custom.tier_prices`,
 * lu ICI pour l'AFFICHAGE et par la FUNCTION pour le PRIX RÉEL.
 * -> ce qui est affiché = ce qui est facturé.
 * ============================================================ */

(function () {
  'use strict';

  try { console.info('[bundle-quantity] v3 (affichage seul) loaded'); } catch (_) {}

  var CONTAINER = '#bundle-tiers';
  var BASE_EL   = 'base-unit-price';
  var EPS       = 0.005; // 0,5 centime

  function qs(s, r)  { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function moneyCH(n) {
    return 'CHF ' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
  }

  // Prix unitaire de base du variant (en CHF), lu depuis #base-unit-price.
  function getBaseUnit() {
    var el = document.getElementById(BASE_EL);
    if (!el) return 0;
    var cents = parseInt(el.getAttribute('data-base-unit-price-cents') || '0', 10);
    return isNaN(cents) ? 0 : cents / 100;
  }

  // Liste des quantités (data-tiers : array JSON ou "1,12,50,...").
  function readTiers(c) {
    var raw = c.getAttribute('data-tiers') || '';
    var arr;
    try { var v = JSON.parse(raw); arr = Array.isArray(v) ? v : []; }
    catch (_) { arr = String(raw).split(/[,\|;\s]+/); }
    return arr.map(function (x) { return parseInt(x, 10); })
              .filter(function (n) { return n > 0; });
  }

  // Prix unitaires par palier (data-tier-prices : JSON, ex. {"1":21.50,"10":19.50}).
  function readTierPrices(c) {
    try {
      var raw = c.getAttribute('data-tier-prices');
      if (!raw || raw === 'null') return {};
      var obj = JSON.parse(raw);
      if (typeof obj === 'string') { try { obj = JSON.parse(obj); } catch (_) { obj = {}; } }
      return (obj && typeof obj === 'object') ? obj : {};
    } catch (_) { return {}; }
  }

  // Reporte la quantité du palier choisi dans tous les formulaires d'ajout au panier.
  function syncFormsQty(c) {
    var sel = qs('input[name="bundle_tier"]:checked', c);
    if (!sel) return;
    var qty = sel.value;
    qsa('form[action*="/cart/add"]').forEach(function (form) {
      var q = qs('input[name="quantity"]', form);
      if (!q) {
        q = document.createElement('input');
        q.type = 'hidden';
        q.name = 'quantity';
        form.appendChild(q);
      }
      q.value = qty;
    });
  }

  // Construit les pills de paliers (une seule fois — plus aucun recalcul dynamique).
  function renderBundle(c) {
    if (!c || c.getAttribute('data-bundle-rendered') === 'true') return;

    var tiers = readTiers(c);
    if (!tiers.length) return;

    var base   = getBaseUnit();
    var prices = readTierPrices(c);

    var html = '<fieldset class="bundle-tier" aria-label="Choisir une quantité">'
             + '<legend>Quantité / Total</legend>';

    tiers.forEach(function (qty, i) {
      var unit  = (prices[String(qty)] != null) ? parseFloat(prices[String(qty)]) : base;
      var total = unit * qty;       // prix réduit du palier (= ce que la Function appliquera)
      var full  = base * qty;       // prix plein (barré)
      var strike = total < full - EPS;

      html += '<label data-bundle-tier="' + qty + '">'
            +   '<input type="radio" name="bundle_tier" value="' + qty + '"' + (i === 0 ? ' checked' : '') + '>'
            +   '<span class="tier-qty">' + qty + ' ex.</span>'
            +   '<span class="tier-price">'
            +     (strike ? '<s>' + moneyCH(full) + '</s> ' : '')
            +     '<strong>' + moneyCH(total) + '</strong>'
            +   '</span>'
            + '</label>';
    });

    html += '</fieldset>';
    c.innerHTML = html;
    c.setAttribute('data-bundle-rendered', 'true');

    // Quantité de départ = 1er palier (coché par défaut).
    syncFormsQty(c);

    // Changement de palier -> on met à jour la quantité envoyée au panier.
    c.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'bundle_tier') syncFormsQty(c);
    });

    // Sécurité : re-sync au moment de l'ajout au panier.
    qsa('form[action*="/cart/add"]').forEach(function (f) {
      f.addEventListener('submit', function () { syncFormsQty(c); });
      var atc = qs('[type="submit"], button[name="add"], .add-to-cart', f);
      if (atc) atc.addEventListener('click', function () { syncFormsQty(c); });
    });
  }

  function init(root) {
    var c = qs(CONTAINER, root || document);
    if (c) renderBundle(c);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  // Rechargement d'une section dans l'éditeur de thème : on autorise un nouveau rendu.
  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    var c = qs(CONTAINER, e.target);
    if (c) c.removeAttribute('data-bundle-rendered');
    init(e.target);
  });
})();